import Swiper, {Navigation, Pagination, Autoplay, Thumbs} from 'swiper/bundle'; // import Swiper bundle with all modules installed

jQuery(document).ready(function ($) {
	"use strict";

    //partner slider
	$('.partner-swiper-outer').each(function(){
		var thisIndex   = $(this).data('slide-index'),
			$this       = '.partner-swiper-outer-' + thisIndex,
			partner_slider = $this + ' .partner-slider';

		if ( $($this + ' .swiper-wrapper').children().length > 6 || $(window).width() < 1024 ) {
			partner_slider = new Swiper(partner_slider, {
				slidesPerView: 5,
				autoplay: true,
				spaceBetween: 10,
				navigation: false,
			});
		} else {
			$($this).addClass('deactivated-slider');
		}
	});

	//cpt slider
	$('.enable-slider .swiper-outer').each(function(){
		var thisIndex   = $(this).data('slide-index'),
			$this       = '.swiper-outer-' + thisIndex,
			cpt_slider  = $this + ' .cpt-slider',
			sliderPagination = $this + ' .swiper-pagination',
			elNext = $this + ' .swiper-button-next',
			elPrev = $this + ' .swiper-button-prev';

		if ( $($this).hasClass('two_items') ) {
			if ( $($this + ' .swiper-wrapper').children().length > 2  || $(window).width() < 1024 ) {
				cpt_slider = new Swiper(cpt_slider, {
					slidesPerView: 1.2,
					navigation: {
						nextEl: elNext,
						prevEl: elPrev,
					},
					breakpoints: {
						640: {
							slidesPerView: 2,
						}
					}
				});
			} else {
				$($this).addClass('deactivated-slider');
			}
		} else {
			if ( $($this + ' .swiper-wrapper').children().length > 3  || $(window).width() < 1024 ) {
				cpt_slider = new Swiper(cpt_slider, {
					slidesPerView: 1.2,
					navigation: {
						nextEl: elNext,
						prevEl: elPrev,
					},
					breakpoints: {
						640: {
							slidesPerView: 2.2,
						},
						992: {
							slidesPerView: 3,
						}
					}
				});
			} else {
				$($this).addClass('deactivated-slider');
			}
		}
	});

	//product-reviews slider
	$('.product-reviews-swiper-outer').each(function(){
		var thisIndex   = $(this).data('slide-index'),
			$this       = '.product-reviews-swiper-outer-' + thisIndex,
			product_reviews_slider = $this + ' .product-reviews-slider',
			sliderPagination = $this + ' .swiper-pagination';

		product_reviews_slider = new Swiper(product_reviews_slider, {
			slidesPerView: 1,
			navigation: false,
			spaceBetween: 10,
			pagination: {
				el: sliderPagination,
				type: 'bullets',
				clickable: true
			},
		});
	});

	//gallery slider
	$('.gallery-slider-outer').each(function(){
		var thisIndex   = $(this).data('slide-index'),
			$this       = '.gallery-slider-outer-' + thisIndex,
			sliderNext  = $this + ' .swiper-button-next',
			sliderPrev  = $this + ' .swiper-button-prev',
			sliderPagination = $this + ' .swiper-pagination';


		var galleryThumbs = new Swiper($this + ' .gallery-thumbs-slider', {
			spaceBetween: 10,
			slidesPerView: 3,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});
		var galleryTop = new Swiper($this + ' .gallery-slider', {

			thumbs: {
				swiper: galleryThumbs,
			},
			navigation: {
				nextEl: sliderNext,
				prevEl: sliderPrev,
			},
			pagination: {
				el: sliderPagination,
				type: 'bullets',
				clickable: true
			},
		});
	});


	if ( $(window).width() < 1024 ) {
		var tiles_slider = new Swiper('.tiles-slider', {
			slidesPerView: 1.2,
			navigation: false,
			pagination: false,
			breakpoints: {
				640: {
					slidesPerView: 2.2,
				},
			}
		});

		var related_slider = new Swiper('.related-slider', {
			slidesPerView: 1.2,
			navigation: false,
			pagination: false,
			breakpoints: {
				640: {
					slidesPerView: 2.4,
				},
			}
		});

	}

	if ( $(window).width() < 1200 ) {
		var cross_sells_slider = new Swiper('.cross-sells-slider', {
			slidesPerView: 2.2,
			navigation: false,
			pagination: false,
			breakpoints: {
				640: {
					slidesPerView: 2.4,
				},
			}
		});
	}

});
